import { Chip, IconButton } from "@mui/material";
import { useAuth } from "../../auth/context";
import { Alert, ButtonWithConfirmation, ErrorAlert, LoadingSpinner } from "../../utils";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { useApi } from "../../utils/hooks";
import { useState } from "react";
import _ from "lodash";

const CancelButton = ({ medicalDocument, setMedicalDocument }) => {
  const { user } = useAuth();
  const api = useApi();
  const [error, setError] = useState();
  const [canceled, setCanceled] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!user.canCancel(medicalDocument) || !medicalDocument.externalId) return;

  if (medicalDocument.status == "canceled") {
    return <Chip label="Anulada" color="error" />;
  }

  const onConfirm = () => {
    setLoading(true);
    api.cancelPrescription(medicalDocument.id)
    .tap(() => {
      setCanceled(true);
      setMedicalDocument(_.assign({}, medicalDocument, { status: "canceled" }));
    })
    .catch(setError)
    .finally(() => setLoading(false));
  };

  return (
    <>
      <ButtonWithConfirmation
        CustomButton={({ onClick }) =>
          <IconButton sx={{ ml: 1 }} onClick={onClick}>
            {loading
              ? <LoadingSpinner isLoading absolute sx={{ top: null }} />
              :  <CancelIcon sx={{ color: "primary.main", fontSize: 25 }}/>
            }
          </IconButton>
        }
        message={`Estás por anular la receta ${medicalDocument.id}. ¿Estás seguro?`}
        onClick={onConfirm}
      />
      <ErrorAlert
        show={!_.isEmpty(error)}
        onClose={() => setError()}
        message="No se pudo anular la receta. Intentá de nuevo o contactanos a consultas@recetario.com.ar"
      />
      <Alert
        severity="success"
        message="Receta anulada con éxito"
        onClose={() => setCanceled(false)}
        show={canceled}
      />
    </>
  );
};

export default CancelButton;
